const globalReducer = window.localStorage.getItem('language')
let isRuInitial = 1
if (globalReducer) {
    isRuInitial = globalReducer === 'ru' ? 1 : 0
} else {
    window.localStorage.setItem('language', 'ru')
}

const initialState = {
    isRu: isRuInitial,
    isLoading: false,
    isGlobalLoading: false
}
export type InitialStateType = typeof initialState;

function globalReducerFn(state = initialState, action: any): InitialStateType {
    switch (action.type) {
        case 'CHANGE_LANGUAGE':
            window.localStorage.setItem('language', state.isRu === 1 ? 'be' : 'ru')
            return {
                ...state,
                isRu: state.isRu === 1 ? 0 : 1,
            }
        case 'SET_GLOBAL_LOADING_VISIBLE':
            return {
                ...state,
                isGlobalLoading: action.value,
            }
        case 'SET_LOADING_VISIBLE':
            return {
                ...state,
                isLoading: action.value,
            }
        default:
            return state
    }
}

export const globalActions = {
    changeLanguage: () => ({type: 'CHANGE_LANGUAGE'} as const),
    setGlobalLoadingVisible: (value: boolean) => ({
        type: 'SET_GLOBAL_LOADING_VISIBLE',
        value,
    } as const),
    setLoadingVisible: (value: boolean) => ({
        type: 'SET_LOADING_VISIBLE',
        value,
    } as const)
}

export default globalReducerFn
